export interface PositionDetail {
    /** Recruitis API ID. */
    apiId: {
        cs: string;
        en: string;
    };
    /** Controls whether the position is in the active
     * or inactive list on the career page. */
    active: boolean | { cs: boolean; en: boolean };
    /** Controls whether the position is displayed in the list
     * on the career page. Can be used for hiding special positions
     * that have custom components on the career page. */
    displayed: boolean | { cs: boolean; en: boolean };
}

export enum Position {
    ANDROID = 'androidDev',
    BACKEND = 'backendDev',
    FRONTEND = 'frontEndDev',
    IOS = 'iOSDev',
    PROJECT_MANAGER = 'projectManager',
    APP_TESTER = 'appTester',
    DESIGNER = 'designer',
    NOT_FOUND = 'careerNotFound',
    INTERN = 'intern',
    ACCOUNT_MANAGER = 'accountManager',
}

type Positions = {
    [key in Position]: PositionDetail;
};

export const positions: Positions = {
    [Position.ANDROID]: {
        apiId: { cs: '386331', en: '389041' },
        active: true,
        displayed: true,
    },
    [Position.BACKEND]: {
        apiId: { cs: '386327', en: '389042' },
        active: true,
        displayed: true,
    },
    [Position.FRONTEND]: {
        apiId: { cs: '386333', en: '389040' },
        active: false,
        displayed: true,
    },
    [Position.IOS]: {
        apiId: { cs: '386335', en: '389045' },
        active: false,
        displayed: true,
    },
    [Position.PROJECT_MANAGER]: {
        apiId: { cs: '386336', en: '389046' },
        active: false,
        displayed: true,
    },
    [Position.APP_TESTER]: {
        apiId: { cs: '386337', en: '389047' },
        active: false,
        displayed: true,
    },
    [Position.DESIGNER]: {
        apiId: { cs: '386338', en: '389048' },
        active: true,
        displayed: true,
    },
    [Position.NOT_FOUND]: {
        apiId: { cs: '387348', en: '387348' },
        active: false,
        displayed: false,
    },
    [Position.INTERN]: {
        apiId: { cs: '406500', en: '413279' },
        active: false,
        displayed: true,
    },
    [Position.ACCOUNT_MANAGER]: {
        apiId: { cs: '415501', en: '' },
        active: { cs: false, en: false },
        displayed: { cs: true, en: false },
    },
};
